"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APSelect = _interopRequireDefault(require("../../common/APSelect"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _APDatePicker = _interopRequireDefault(require("../../common/APDatePicker/APDatePicker"));
var _formValidations = require("../../../helpers/formValidations");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _ReportAccountsComponent = _interopRequireDefault(require("../ReportAccountsComponent"));
require("../ReportFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('report-form');
var ScheduleReportFormComponent = function ScheduleReportFormComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var accounts = props.accounts,
    handleSubmit = props.handleSubmit,
    buttonDisabled = props.buttonDisabled;
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit,
    className: baseClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('form-body')
  }, /*#__PURE__*/_react["default"].createElement(_ReportAccountsComponent["default"], {
    accounts: accounts
  }), /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "type",
    label: t("Report Type:"),
    customClass: baseClasses(),
    validate: [_formValidations.required],
    options: [{
      value: 'TradeActivity',
      label: t("Trade Activity")
    }, {
      value: 'Transaction',
      label: t("Transaction")
    }, {
      value: 'Treasury',
      label: t("Treasury")
    }, {
      value: 'ProductDelta',
      label: t("Product Delta")
    }, {
      value: 'PnL',
      label: t("Profit and Loss")
    }],
    showTriangles: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('datapicker-container')
  }, /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "startDate",
    label: t("Start Date:"),
    minDate: new Date(),
    customClass: baseClasses(),
    validate: [_formValidations.required],
    initialOptions: {
      theme: 'retail'
    }
  }), /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "frequency",
    label: t("Frequency:"),
    customClass: baseClasses(),
    classModifiers: "small",
    validate: [_formValidations.required],
    options: [{
      value: 'Hourly',
      label: t("Hourly")
    }, {
      value: 'Daily',
      label: t("Daily")
    }, {
      value: 'Weekly',
      label: t("Weekly")
    }, {
      value: 'Monthly',
      label: t("Monthly")
    }, {
      value: 'Annual',
      label: t("Annual")
    }],
    showTriangles: true
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('footer')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    customClass: baseClasses(),
    styleName: "additive",
    disabled: buttonDisabled
  }, t("Create"))));
};
ScheduleReportFormComponent.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ScheduleReportFormComponent;